import React from "react";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

function LeftNav() {
  const { role } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Helper to determine active app context from the URL path
  const getSelectedAppFromPath = (path) => {
    if (path.includes("/admin/simplecheck")) {
      return "SimpleCheck";
    }
    if (path.includes("/admin/simplespect")) {
      return "SimpleSpect";
    }
    if (
      path.includes("/admin/applications") ||
      path.includes("/admin/invoices")
    ) {
      return "SimplePermits";
    }
    return "Default"; // for /admin/dashboard, /admin/portal-users, /admin/portal-settings, /admin/communities
  };

  const selectedApp = getSelectedAppFromPath(location.pathname);

  // Define logo based on selected app
  const getLogo = () => {
    switch (selectedApp) {
      case "SimpleCheck":
        return `${process.env.PUBLIC_URL}/simplechecklogo.png`;
      case "SimpleSpect":
        return `${process.env.PUBLIC_URL}/simplespect.png`;
      case "SimplePermits":
        return `${process.env.PUBLIC_URL}/logo.svg`;  
      default:
        return `${process.env.PUBLIC_URL}/logo.svg`;
    }
  };

  const setApplicaton = () => {
    navigate("/admin/dashboard");
  };

  return (
    <aside className="sidebar text-center">
      {/* Dynamic Logo */}
      <img src={getLogo()} alt="Logo" className="admin-logo mb-3 mt-2" />

      <nav className="menu">
        {role === "Admin" && (
          <>
            {/* Default Links */}
            {selectedApp === "SimplePermits" && (
              <>
                <NavLink to="/admin/applications" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/Home.svg`} alt="" className="px-2" />
                  Applications
                </NavLink>
                <hr />
                {/* <NavLink to="/admin/invoices" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/Pie-Chart.svg`} alt="" className="px-2" />
                  Billing and Invoice
                </NavLink>
                <hr /> */}
              </>
            )}

            {/* Main Panel App Selectors */}
            {selectedApp === "Default" && (
              <>
                <div className="menu-item main-link" onClick={() => navigate("/admin/applications")} style={{ cursor: "pointer" }}>
                  <img src={`${process.env.PUBLIC_URL}/logo.svg`} alt="" className="px-2" style={{ maxWidth: "50px" }} />
                  Simplepermit ™
                </div>
                <div className="menu-item main-link" onClick={() => navigate("/admin/simplecheck/application")} style={{ cursor: "pointer" }}>
                  <img src={`${process.env.PUBLIC_URL}/simplechecklogo.png`} alt="" className="px-2" style={{ maxWidth: "50px" }} />
                  Simplecheck ™
                </div>
                <div className="menu-item main-link" onClick={() => navigate("/admin/simplespect/application")} style={{ cursor: "pointer" }}>
                  <img src={`${process.env.PUBLIC_URL}/simplespect.png`} alt="" className="px-2" style={{ maxWidth: "50px" }} />
                  Simplespect ™
                </div>
                <hr className="my-3" />
                <NavLink to="/admin/communities" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/application.svg`} alt="" className="px-2" style={{ width: "24px" }} />
                  Communities
                </NavLink>
                <hr className="my-2" />
                <NavLink to="/admin/portal-users" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/application.svg`} alt="" className="px-2" style={{ width: "24px" }} />
                  Portal Users
                </NavLink>
                <hr className="my-2" />
                <NavLink to="/admin/portal-settings" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/Pie-Chart.svg`} alt="" className="px-2" style={{ width: "24px" }} />
                  Portal Settings
                </NavLink>
                <hr className="my-2" />
                <NavLink to="/admin/system-storage" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/Pie-Chart.svg`} alt="" className="px-2" style={{ width: "24px" }} />
                  System Storage
                </NavLink>
              </>
            )}

            {/* Show menus when SimpleCheck is selected */}
            {selectedApp === "SimpleCheck" && (
              <>
                <NavLink to="/admin/simplecheck/application" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/application.svg`} alt="" className="px-2" />
                  Plan Review Request
                </NavLink>
              </>
            )}

            {selectedApp === "SimpleSpect" && (
              <>
                <NavLink to="/admin/simplespect/application" className={({ isActive }) => (isActive ? "active" : "")}>
                  <img src={`${process.env.PUBLIC_URL}/application.svg`} alt="" className="px-2" />
                  Inspection Request
                </NavLink>
              </>
            )}
          </>
        )}

        {role === "Community" && (
          <>
            <NavLink to="/community-portal/dashboard" className={({ isActive }) => (isActive ? "active" : "")}>
              <img src={`${process.env.PUBLIC_URL}/application.svg`} alt="" className="px-2" style={{ width: "24px" }} />
              Applications
            </NavLink>
            <hr className="my-2" />
            <NavLink to="/community-portal/signatures" className={({ isActive }) => (isActive ? "active" : "")}>
              <img src={`${process.env.PUBLIC_URL}/consent-form.svg`} alt="" className="px-2" style={{ width: "24px" }} />
              Signatures
            </NavLink>
          </>
        )}
      </nav>

      {/* Back Button to Return to Default */}
      {selectedApp !== "Default" && (
        <button className="btn btn-outline-secondary mt-3" onClick={() => setApplicaton()}>
          Back to Main Panel
        </button>
      )}
    </aside>
  );
}

export default LeftNav;
